import CategoryCard from '@/components/feature/CategoryCard';
import { categories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索调教分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大专业分类，覆盖从宠物训练到自我提升的全部调教领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.slug}
              slug={cat.slug}
              name={cat.name}
              description={cat.description}
              icon={cat.icon}
              imageUrl={cat.imageUrl}
              articleCount={cat.articleCount}
            />
          ))}
        </div>
      </div>
    </section>
  );
}